import React, { FC, useState } from 'react';

import { useStore } from '@vromo/mobx-react/mobx-react';
import { RootStore } from '../stores/RootStore';
import { update } from 'serializr';
import Modal from '@vromo/ui/components/Modal';
import SelectSingle from '@vromo/ui/components/Select';
import Button from '@vromo/ui/components/Button';
import { EntityList, Job, Vehicle } from '@vromo/models';

interface Props {
    vehicles: Vehicle[];
    isOpen: boolean;
    close: (a?: boolean) => void;
    selected: Set<number>;
    jobs: EntityList<Job>;
}
/** old job dispatch modal 
 * @deprecated 
 * */
const DispatchModal: FC<Props> = ({ vehicles, isOpen, close, selected, jobs }) => {
    const [vehicle, setVehicle] = useState(vehicles[0]?.id ?? null);

    const {
        authStore: { graph, role },
        vehicleStore,
        groupStore
    } = useStore<RootStore>('rootStore');

    function save() {
        graph.root
            .graph()
            .roles(role.id)
            .jobs()
            .post(
                Array.from(selected).map((id: number) => ({
                    id,
                    dispatches: [
                        {
                            type: 'dispatched',
                            vehicle: { id: vehicle }
                        }
                    ]
                }))
            )
            .then(() => {
                update(jobs, {
                    type: 'update',
                    items: Array.from(selected).map((it) => ({
                        id: it,
                        status: 'dispatched',
                        dispatches: {
                            type: 'create',
                            items: [
                                {
                                    type: 'dispatched',
                                    vehicle: { id: vehicle }
                                }
                            ]
                        }
                    }))
                });

                close(true);
            });
    }

    return (
        <Modal onRequestClose={() => close()} isOpen={isOpen}>
            Dispatch {selected.size} jobs to:
            <SelectSingle
                value={JSON.stringify(vehicle)}
                onChange={(e) => setVehicle(JSON.parse(e.target.value))}>
                {vehicles.map((it) => (
                    <option key={it.id} value={it.id!}>
                        {it.displayName(
                            vehicleStore.driverVehicleMap,
                            groupStore.withId(it.group!)
                        )}
                    </option>
                ))}
            </SelectSingle>
            <Button onClick={save}>Dispatch</Button>
        </Modal>
    );
};

export default DispatchModal;
